module.exports = __webpack_public_path__ + "static/media/crack.86086b4c.jpg";